import { Component } from '@angular/core';

@Component({
  selector: 'fc-sample-layout',
  templateUrl: './sample-layout.html',
  styleUrls: ['./sample-layout.scss'],
})
export class SampleLayoutComponent {



  //************************************************************


  fillerContent = Array(30);
  fixed = false;
  coverHeader = false;
  showHeader = false;
  showFooter = false;
  modeIndex = 0;
  get mode() { return ['side', 'over', 'push'][this.modeIndex]; }
  get fixedTop() { return this.fixed && this.showHeader && !this.coverHeader ? 64 : 0; }
  get fixedBottom() { return this.fixed && this.showFooter && !this.coverHeader ? 64 : 0; }


}



// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/sample/containers/sample-layout/sample-layout.ts